import type { SectionState } from "../navigation";

export interface OrganizationSectionStatusIconProps {
  state: SectionState;
}

export function OrganizationSectionStatusIcon({
  state,
}: OrganizationSectionStatusIconProps) {
  const isComplete = state === "complete";
  const stateClass =
    state === "yellow"
      ? "border-[var(--status-warning)] text-[var(--status-warning-text)]"
      : state === "red"
        ? "border-[var(--status-error)] text-[var(--status-error)]"
        : "border-(--border-default) text-(--fg-muted)";

  return (
    <span
      className={[
        "inline-flex h-5 min-w-9 shrink-0 items-center justify-center rounded-[3px] px-[7px] font-mono text-[10px] font-semibold tracking-[-0.02em] tabular-nums",
        isComplete
          ? "bg-(--brand-navy) text-(--fg-inverse)"
          : `border-[1.5px] bg-transparent ${stateClass}`,
      ].join(" ")}
      role="img"
      aria-label={isComplete ? "Complete" : "Needs attention"}
    >
      {isComplete ? (
        <svg
          aria-hidden="true"
          width="11"
          height="11"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12.5l4 4 10-10" />
        </svg>
      ) : (
        <svg
          aria-hidden="true"
          width="11"
          height="11"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 4L22 20H2L12 4Z" />
          <path d="M12 11v3" />
          <path d="M12 17h.01" />
        </svg>
      )}
    </span>
  );
}
